import "./Motto.scss";

const Motto = () => {
  return (
    <section className="home-motto__wrapper">
      <div className="home-motto__container">
        <div className="home-motto__text-con">
          <h3>Eat. Connect. Share.</h3>
          <p>Join a vibrant community of food lovers and chefs worldwide</p>
          <div>
            <a
              href="https://apps.apple.com/app/skibble-food-social-network/id1633887491"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/app_store.png" alt="" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.mcfranchostudios.skibble"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/playstore.png" alt="" />
            </a>
          </div>
        </div>
      </div>
      <div className="home-motto__container-mobile">
        <div className="home-motto__text-con-mobile">
          <h3>
            Eat. <br /> Connect. <br /> Share.
          </h3>
          <p>Join a vibrant community of food lovers and chefs worldwide</p>
          <div>
            <a
              href="https://apps.apple.com/app/skibble-food-social-network/id1633887491"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/app_store.png" alt="" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.mcfranchostudios.skibble"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/playstore.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Motto;
